/**
 * Add a Track to the connection.
 * @method addTrack
 * @param  {Track} track A Track object.
 * @return {RTCRtpSender}
 */
export default function addTrack (track) {
  const { nativePeer, log } = this
  log.info(`Adding new ${track.track.kind} track.`)

  let sender
  try {
    sender = nativePeer.addTrack(track.track, track.getStream())
  } catch (err) {
    // TODO: Better error handling.
    log.info(`Failed to add track: ${err.message}`)
  }
  // TODO: What to return here? Probably shouldn't expose the rtpSender itself.
  return sender
}
